import {TableColumnsType} from 'antd';

import {Locale} from '../../../../provider/locale/locale';

import {StoriesTableRenderingType} from './stories-table-type';

export const storiesTableColumnList: TableColumnsType<StoriesTableRenderingType> = [
    {
        title: <Locale stringKey="POSTS__TABLE__TITLE" />,
        dataIndex: 'title',
    },
    {
        title: <Locale stringKey="POSTS__STORIES_TABLE__PREVIEW" />,
        dataIndex: 'preview',
        width: 80,
    },
    {
        title: <Locale stringKey="YANDEX_STORY__STATUS" />,
        dataIndex: 'status',
    },
    {
        title: <Locale stringKey="YANDEX_STORY_FORM__CONFIRMATION_STEP__PUBLISH_AT" />,
        dataIndex: 'publishAt',
    },
    {
        title: <Locale stringKey="YANDEX_STORY_FORM__CONFIRMATION_STEP__DELETE_AT" />,
        dataIndex: 'deleteAt',
    },
    {
        title: <Locale stringKey="POSTS__TABLE__COMPANIES_COUNT" />,
        dataIndex: 'companiesCount',
    },
    {
        title: <Locale stringKey="POSTS__TABLE__DATE" />,
        dataIndex: 'date',
    },
    {
        title: <Locale stringKey="POSTS__TABLE__ACTIONS" />,
        dataIndex: 'actions',
        width: 100,
    },
];
